<template>
    <v-list-item :key="model.name" @click.stop="selectFile" class="project-tree-fileitem" v-bind:class="{ 'selected-item': ( globalState.selectedID === modelID )}">
        <v-list-item-action>
            <v-img :src="imgSrc" max-width="24"></v-img>
        </v-list-item-action>
        <v-list-item-content>
            <v-list-item-title style="height: 100%;display: flex;align-items: center;gap:8px;" v-bind:class="{ gray: ( !node.permissions.can_i_read || model.readonly ) }">
                <span>{{model.title}}</span>
                <span class="inlineDetails">Rev:<b style="margin-right: 8px;">{{Number.parseInt(lastVer[0])}}</b> V:{{lastVer[1]}}</span>
                <v-icon color="red lighten-2" v-if="model.is_checked_out_by_me || model.is_checked_out_by_user">lock</v-icon>
                <v-icon color="red lighten-2" v-if="model.red_flags && model.red_flags.length > 0">flag</v-icon>
                <v-badge overlap color="blue lighten-3" v-if="getStickNum( model ) > 0">
                    <span slot="badge">{{ getStickNum( model ) }}</span>
                    <v-icon color="yellow darken-3" @click="procFunc( 'openNotes' )">subject</v-icon>
                </v-badge>
<!--                <v-badge overlap color="blue lighten-3">
                    <span slot="badge">{{ getLinkNum( model ) }}</span>
                    <v-icon color="green darken-2" v-if="getLinkNum( model )" @click="openLinks( model )">link</v-icon>
                </v-badge>  -->
            </v-list-item-title>
        </v-list-item-content>
    </v-list-item>
    
</template>

<script>

import FeaturesSet from "@/utils/features"

export default {
  name: 'NodeListRow',
  props: {
      model: {},
      node: { permissions: {} },
  },
  data () {
    return {
        fs: FeaturesSet,
         globalState: this.$globalStore.state
    };
  },
  computed: {
    isConvType: function()
    {
        return ( this.model.data_type && 
                ( this.model.data_type.toLowerCase() === '.stp' || this.model.data_type.toLowerCase() === '.step' ) );
    },
    imgSrc: function()
    { 
        try
        {
            var ext = this.model.data_type.split( '.' );
            ext = ext[ 1 ].toLowerCase();
            if( ext === 'docx' )
                ext = 'doc';
            else if( ext === 'step' )
                ext = 'stp';
            else if( ext === 'pptx' )
                ext = 'ppt';
            return require( '../../assets/file_icons/' + ext + '.png' );             
        }
        catch( err )
        {
//            console.log( err );
            return require( '../../assets/file_icons/_blank.png' );             
        }
    },
    modelID: function()
    {
        return this.model.instance_id;
    },
    lastVer: function()
    {
        return this.model.versions[ this.model.versions.length - 1 ].version_id.split( '.' );
    }
  },
  methods: 
  {
      openHelp( link )
      {
          this.$utils.openHelp( link );
      },
      showHistory()
      {
          this.$modalDlg.sysDlgs.fileHistoryDlg.open( this.model, this.node )
                  .then( () => {}, () => {} );
      },
      selectFile()
      {
          this.$eventBus.$emit( 'updateFile', { file: this.model, node: this.node } );  
          this.$globalStore.setSelectedID( this.model.instance_id );          
          this.$eventBus.$emit( 'setURLData', { file: this.model.instance_id } );  
      },
      getLinkNum( file )
      {
          var num = 0;
          if( file.affects_documents )
              num += file.affects_documents.length;
          if( file.affected_by_documents )
              num += file.affected_by_documents.length;
      
          return num;
      },
      getStickNum( file )
      {
          var ver = file.versions[ file.versions.length - 1 ];
          if( !ver.sticky_notes )
              return 0;
          else
              return ver.sticky_notes.length;
      },
      procFunc: function( cmd )
      {
          this.showMenu = false;      
          this.$eventBus.$emit( 'procRowMenuCmd', [ cmd , this.model, this.node ] );       
      },  
      procModel()
      {
          this.$utils.sortArray( this.model.versions, ( a ) => ( a.version_id ) );
          var lastVer = this.model.versions[ this.model.versions.length - 1 ];
          this.model.last_ver = lastVer.version_id + ' [' + lastVer.date_submitted + ']';
          this.model.last_ver_user = lastVer.submitted_by_user;
          this.model.last_ver_id = lastVer.version_id;
          this.model.last_ver_date = lastVer.date_submitted;
          this.model.last_ver_phase = lastVer.phase;
//          console.log( this.model );
      }
  },
  components: {
  },
  watch: {
      model() 
      {
          this.procModel();
      }
  },
  mounted: function() 
  { 
      this.procModel();
  },   
  beforeDestroy: function()
  {
  }
}
</script>

<style scoped>
    .selected-item
    {
        background-color: var(--brand-main-color) !important;
        color: white !important;
    }
    .back
    {
        font-weight: 600;
        font-size: 20px;
    }
    .gray
    {
        color: gray;
    }
    .inlineDetails{
        border: 1px solid #EEEEEE;
        border-radius: 5px;
        padding: 2px 5px 0;
        height: 21px;
        color: #AAA;
        font-size: 75%;
        background-color: #FFF;
        position: sticky;
        z-index: 2;
        right: 0;
        display: inline-flex;
        align-items: center;
        line-height: initial;
        white-space: nowrap;
    }
    .selected-item .inlineDetails{
        background-color: var(--brand-main-color) !important;
        color: #dddddd;
        border: 1px solid #eeeeee36;
    }
    .selectCl
    {
        font-size: 13px;
    }
    .project-tree-fileitem.v-list-item >>> .v-btn .v-icon{
        color: #DDD;
    }
    .project-tree-fileitem.v-list-item:hover >>> .v-btn .v-icon{
        color: #666 !important;
    }
    .project-tree-fileitem.v-list-item.selected-item >>> .v-btn .v-icon{
        color: #DDD;
    }
    .project-tree-fileitem.v-list-item:hover.selected-item >>> .v-btn .v-icon{
        color: #fff !important;
    }
    .v-list-item >>> .v-list-item__content{
        padding: 0 !important;
    }
    .v-list-item >>> .v-list-item__title{
        line-height: 1.5em;
    }
</style>
